import React, { useContext, useEffect, useState } from 'react';
import styles from './ServiceCardsAnim.module.scss';
import SwiperCustom from 'components/SwiperCustom/SwiperCustom';
import { SwiperSlide } from 'swiper/react';
import { addCustomPathToLink, generateKey } from '../../functions';
import { Link } from 'react-router-dom';
import Lottie from 'lottie-react';
import 'swiper/css';
import { DataContext } from '../../views/pages/Root';

const ServiceCards = ({ api }) => {
  const data = useContext(DataContext);
  const subcategories = api.attributes?.subcategories;

  return (
    <section
      id={api?.id}
      className={styles.ServiceCardsAnim}
      data-aos="fade-up"
      // data-aos-delay="50"
      data-aos-duration="500"
      data-aos-easing="ease-in-out"
      data-aos-once="false"
      // data-aos-anchor-placement="top-center"
    >
      {!!api.attributes.title && (
        <h2
          className={styles.tittleSection}
          data-aos="fade-up"
          // data-aos-delay="300"
          data-aos-duration="500"
          data-aos-easing="ease-in-out"
          data-aos-once="false"
          // data-aos-anchor-placement="top-center"
        >
          {api.attributes.title}
        </h2>
      )}
      <SwiperCustom
        type="swiperthreeCards"
        spaceBetween={10}
        slidesPerView={1.3}
        breakpoints={{
          992: {
            slidesPerView: !!api.attributes?.subcategories ? Math.min(api.attributes.subcategories.length, 4) : 4,
          },
        }}
      >
        {!!subcategories &&
          !!api?.attributes?.subcategories?.length &&
          api.attributes.subcategories.map((subCat) => (
            <SwiperSlide className={styles.swiperSlide} key={generateKey()}>
              <figure className={styles.borderAnim}>
                {!!subCat?.animationName && (
                  <Lottie
                    autoplay="true"
                    animationData={!!data?.animations2?.length && data.animations2.find((prop) => prop.name == subCat.animationName)?.value}
                    loop={true}
                    className={styles.cardImage}
                  ></Lottie>
                )}
                {!subCat?.animationName && !!subCat?.image?.src && (
                  <img className={styles.cardImage} src={addCustomPathToLink(subCat.image.src, true)} alt={subCat.image.alt} />
                )}
              </figure>
              {!!subCat?.title && <h4 className={styles.titleCards}>{subCat.title}</h4>}
              {!!subCat?.description && <p className={styles.descCards}>{subCat.description}</p>}
              {!!subCat?.btntext && !!subCat?.btnlink && (
                <Link className={styles.productTitle} to={addCustomPathToLink(`${subCat?.btnlink}`)}>
                  {subCat?.btntext}
                </Link>
              )}
            </SwiperSlide>
          ))}
      </SwiperCustom>
    </section>
  );
};
export default ServiceCards;
